import PropTypes from 'prop-types';
import React from 'react';
import SimpleReactValidator from '../../components/validator';
import {Chip, Column, DataTable, ProgressBar} from 'primereact';
import QuizService from '../../services/QuizService';
import BaseContainer from '../../baseContainers/BaseContainer';
import {t} from 'i18next';

class SurveyResultComponent extends BaseContainer {
    constructor(props) {
        super(props);
        this.state = {
            quizId: props.quizId,    
            answerUserCountList: [],
            userCountResponse: undefined,
        };
        this.service = new QuizService()
        this.renderHeader=this.renderHeader.bind(this);
    }

    componentDidMount() {        
        this.service
            .getSurveryAnswersUsersCount(this.state.quizId)
            .then((data) => {
                this.setState({
                    userCountResponse: data,
                    answerUserCountList: data.answerUserCountList
                })
            }).catch((err) => {
                this.showErrorMessage('Nie udało się pobrać wyników ankiety')
            });
    }


    renderHeader(element) {
        const sum =
            this.state?.answerUserCountList
                .filter((x) => x.quizQuestionId === element.id)
                .map((x) => x.count)
                .reduce((x, y) => x + y, 0);

        return (
            <div>
                <span>
                    {`Pytanie: ${element.question} \n`}
                </span>
                <span>
                    {sum === 1 ?
                        `Na pytanie odpowiedział ${sum} użytkownik `
                        : `Na pytanie odpowiedziało ${sum} użytkowników `
                    }
                </span>
            </div>
        )
    }

    renderText(element) {
        return (
            <Chip style={{
                color: "black",
            }} label={element.text} />
        );
    }

    percentage(partialValue, totalValue) {
        return (100 * partialValue) / totalValue;
    }

    renderProgressBar(answerId) {
        const percentage = this.state?.answerUserCountList
            .filter((x) => x.answerId === answerId)
            .map((x) => x.percentage)[0];

        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-start'
                }}
            >
                <ProgressBar
                    value={percentage}
                    style={{
                        width: '350px',
                        borderRadius: '15px',
                        height: '14px'
                    }}
                    color={'blue'}
                    showValue={false}
                />
                {this.renderPercentNumber(percentage)}
            </div>
        )
    }
    renderPercentNumber(percentage) {
        return (<div
            style={{
                marginLeft: '20px',
                width:'50px'
            }}
        >
            {`${percentage ? percentage : 0} %`}
        </div>
        )
    }
    getCount(element) {
        const result = this.state?.answerUserCountList
            .filter((x) => x.answerId === element.id)
            .map((x) => x.count)[0];
        return result ? result : 0;
    }

    render() {
        return this.props.questions ? this.props.questions.map((element) => {  
            return (       
                <DataTable
                    value={element.answerOptions}
                    style={{
                        width: 'fit-content'
                    }}
                    header={this.renderHeader(element)}
                >
                    <Column field='text' body={this.renderText} header={t('survey.answer')}></Column>
                    <Column field='result' body={this.getCount.bind(this)} header={t('survey.answerCount')}></Column>
                    <Column field='result' body={(x) => this.renderProgressBar(x.id)} header={t("survey.percentageResult")}></Column>
                </DataTable>
            );
        }) : null;
    }

}
    

SurveyResultComponent.defaultProps = {
    element: null,
    idPrefix: '',
    stateField: 'element',
    colClass: 'col-md-4',
    disabled: false,
};

SurveyResultComponent.propTypes = {
    element: PropTypes.object,
    answerTypeOptions: PropTypes.array,
    idPrefix: PropTypes.string,
    stateField: PropTypes.string,
    viewMode: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    onErrorMessage: PropTypes.func.isRequired,
    validator: PropTypes.instanceOf(SimpleReactValidator).isRequired,
};

export default SurveyResultComponent;
